import type { App } from 'vue';

import SvgVueComponent from '@/application/components/SvgVue';

export const SvgVue = {
  install(app: App): void {
    app.component('SvgVue', SvgVueComponent);
  },
};
